import { all, call, put, debounce, take } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import {
  initGiftState,
  initGiftStateFailure,
  initGiftStateSuccess,
  reduxInitialized,
} from './actions';
import type { PapiDaUserProfileGiveMenuStatus } from '@wix/da-papi-types';

export function* handleInitGiftState(action: ReturnType<typeof initGiftState>) {
  const { user } = action.payload;

  const result: PapiDaUserProfileGiveMenuStatus = yield call(
    requestPuppy,
    {
      method: 'get',
      url: 'give_menu/status',
      params: {
        username: user.username,
      },
    },
    undefined,
    'dauserprofile'
  );

  if (!result || isApiError(result)) {
    yield put(initGiftStateFailure(user));
    return;
  }

  yield put(
    initGiftStateSuccess(user, {
      canBeGivenLlama: result.canGiveLlama,
      canBeGivenCake: result.canGiveCake,
      canBeGivenCore: result.canGiveCore,
    })
  );
  return;
}

export function* giftingSaga() {
  // This redux module is loaded dynamically, so wait for it to initialize before setting up our sagas

  take(reduxInitialized);
  yield all([debounce(500, initGiftState, handleInitGiftState)]);
}
